import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X3LevelStore} from '../X3LevelStore';

@observer
export class MoveUnitControls extends React.Component<{ store: X3LevelStore }> {
  render() {
    const {store} = this.props;

    if (store.move === null)
      return null;

    const move = store.move;
    const isPending = move.save?.isPending === true;

    return (<>
      <div className="row justify-content-end">
        <div className="col-auto">
          <button type="button" className="btn btn-primary"
                  onClick={store.completeMove}
                  disabled={isPending}>
            Save
          </button>
          <button type="button" className="btn btn-primary"
                  onClick={store.cancel}
                  disabled={isPending}>
            Cancel
          </button>
        </div>
      </div>

      <PromiseMessage label="Saving" state={move.save} align="right"/>
    </>);
  }
}
